import React, { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

interface Props {
  lat: number;
  lng: number;
  enabled: boolean;
}

/** Imperatively pans the map when coords change externally (address search, marker drag, manual input) without blocking free panning. */
const MapCenterSync: React.FC<Props> = ({ lat, lng, enabled }) => {
  const map = useMap();
  useEffect(() => {
    if (!map || !enabled) return;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
    map.panTo({ lat, lng });
  }, [map, lat, lng, enabled]);
  return null;
};

export default MapCenterSync;
